"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M.2 8.502a.46.46 0 00-.2.376v.004c0 .061.014.123.04.183l2.3 5.022c.1.22.36.328.6.247 1.504-.517 6.713-2.152 10.085-1.273 0 0-3.38.193-6.44 2.504a.452.452 0 00-.14.551l1.028 2.242.396.896c.094.213.396.236.528.043.714-1.036 1.916-1.553 3.072-2.006a18.08 18.08 0 013.68-1.01c1.34-.22 2.713-.278 4.069-.163a.484.484 0 00.504-.324l1.04-3.198a.454.454 0 00-.18-.51c-1.156-.81-5.74-3.525-13.801-2.435 0 0 6.88-3.807 15.61.378a.49.49 0 00.675-.277l.914-2.82a.513.513 0 00.02-.135v-.012a.455.455 0 00-.244-.395C22.662 5.794 18.952 4 13.847 4 9.935 4 5.207 5.053.2 8.502z" }), "Stadia");
//# sourceMappingURL=Stadia.js.map